module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="notify loader-results">\n	<h3>'+
((__t=( __('loading_text') ))==null?'':__t)+
'</h3>\n	<img src="/tramino/gfx/loading_anim.gif">\n</div>\n';
}
return __p;
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/mitch/jsapps/modules/reserva/templates/engine/loader-results.html
 ** module id = 58
 ** module chunks = 0
 **/